import { apiV1 } from './api';

const getStructureTypes = () => apiV1.get('/structure_types');

export { getStructureTypes };
